import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgRedo = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 25 25"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M19.562 21.584a11.322 11.322 0 0 0 4.36-8.937 11.33 11.33 0 0 0-11.324-11.34C6.326 1.3 1.24 6.378 1.24 12.648c0 3.55 1.63 6.717 4.185 8.795.1.08.244.062.324-.037l1.117-1.432a.227.227 0 0 0-.034-.314 9.035 9.035 0 0 1-2.609-3.485 8.924 8.924 0 0 1-.714-3.527 9.035 9.035 0 0 1 2.657-6.414 9.035 9.035 0 0 1 6.416-2.657 9.035 9.035 0 0 1 6.414 2.657 9.035 9.035 0 0 1 2.657 6.414 9.035 9.035 0 0 1-2.657 6.414c-.264.263-.542.51-.831.736L17.01 18.32a.227.227 0 0 0-.4.085l-1.123 4.6a.228.228 0 0 0 .219.28l4.735.023c.19 0 .298-.219.178-.366l-1.057-1.358Z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
)

const ForwardRef = forwardRef(SvgRedo)
const Memo = memo(ForwardRef)
export default Memo
